import SiteComponentReducers from 'yoda-site-components/lib/reducers';
import CreateAccountReducer from 'yoda-site-components/lib/reducers/CreateAccountReducer';
import WebvitalsReducer from 'yoda-site-components/lib/reducers/WebvitalsReducer';
import MyListNameReducer from 'yoda-account-components/lib/reducers/MyListNameReducer';
import SignInReducer from 'yoda-site-components/lib/reducers/SigninReducer';
import SYFQuickScreenReducer from 'yoda-account-components/lib/reducers/SYFQuickScreenReducer';
import AccountDetailsReducer from './AccountDetailsReducer';
import AddressReducer from './AddressReducer';
import RegistryReducer from './RegistryReducer';
import NotificationReducer from './NotificationReducer';
import PaymentReducer from './PaymentMethodsReducer';
import AddressingConstReducer from './AddressingConstReducer';
import CouponsReducer from './CouponsReducer';
import MyInfoAddressReducer from './MyInfoAddressReducer';
import GroupReducer from './GroupReducer';

const rootReducer = {
    /*
    node_modules/yoda-account-components/lib/components/CreateAccount/Page/CreateAccountConnect.jsx
    node_modules/yoda-account-components/lib/components/CreateAccount/Page/CreateAccountWrapper.jsx
    node_modules/yoda-account-components/lib/components/CreateAccount/CreateAccountForm.jsx
    */
    CreateAccount: CreateAccountReducer,
    /*
    src/containers/Pages/CAMDashboard/CAMDashboard.jsx
    node_modules/yoda-site-components/lib/components/CAMNav/WithLayout.jsx
    node_modules/yoda-site-components/lib/components/CAMNav/CAMNav.jsx
    node_modules/yoda-site-components/lib/components/CAMNav/sub-components/NavItem.jsx
    node_modules/yoda-site-components/lib/components/CreateMyList/CreateMyList.jsx
    */
    camNavMyList: MyListNameReducer,
    ...SiteComponentReducers,
    /*
    node_modules/yoda-account-components/lib/components/Login/Page/SignInConnect.jsx
    node_modules/yoda-account-components/lib/components/Login/Page/SignInWrapper.jsx
    */
    signInDetails: SignInReducer,
    /*
    src/containers/Pages/CAMDashboard/Components/WalletWrapper.jsx
    src/components/MyWallet/MyWalletPage.jsx
    src/components/MyWallet/MyWalletRewards.jsx
    */
    // launchNLearnDetails: LaunchNLearnReducer,
    /*
    node_modules/yoda-account-components/lib/components/CreateAccount/Page/CreateAccountConnect.jsx
    node_modules/yoda-account-components/lib/components/CreateAccount/Page/CreateAccountWrapper.jsx

    node_modules/yoda-account-components/lib/components/Login/Page/SignInConnect.jsx
    node_modules/yoda-account-components/lib/components/Login/Page/SignInWrapper.jsx
    node_modules/yoda-account-components/lib/components/SignInSlider/wrappers/LoginWrapper.jsx
    */
    groupDetails: GroupReducer,
    /*
    src/containers/Pages/CAMDashboard/CAMDashboardConnect.jsx
    src/containers/Pages/CAMDashboard/CAMDashboard.jsx

    src/containers/Pages/CAMDashboard/Components/MyDetailsWrapper.jsx
    src/components/ProfileSettings/ProfileSettings.jsx

    src/components/MyWallet/WalletBarcodeSnapshot/WalletBarcodeSnapshotConnect.jsx
    */
    accountDetails: AccountDetailsReducer,
    /*
    src/components/MyWallet/WalletAddCreditCardSlider/WalletAddCreditCardSliderConnect.jsx
    src/components/MyWallet/WalletAddCreditCardSlider/WalletAddCreditCardSlider.jsx
    src/components/MyWallet/WalletAddCreditCard/WalletAddCreditCard.jsx

    src/containers/Pages/CAMDashboard/Components/MyAddressesWrapper.jsx
    src/components/MyInfoAddresses/MyInfoAddresses.jsx

    src/containers/Pages/CAMDashboard/Components/WalletWrapper.jsx
    src/components/MyWallet/MyWalletPage.jsx
    src/components/MyWallet/MyWalletPayment.jsx
    */
    addressDetails: AddressReducer,
    /*
    node_modules/yoda-account-components/lib/components/CreateAccount/Page/CreateAccountConnect.jsx
    node_modules/yoda-account-components/lib/components/CreateAccount/Page/CreateAccountWrapper.jsx

    node_modules/yoda-account-components/lib/components/Login/Page/SignInConnect.jsx
    node_modules/yoda-account-components/lib/components/Login/Page/SignInWrapper.jsx
    node_modules/yoda-account-components/lib/components/SignInSlider/wrappers/LoginWrapper.jsx
    */
    registryDetails: RegistryReducer,
    /*

    src/containers/Pages/CAMDashboard/Components/PreferencesWrapper.jsx
    src/components/Preferences/Preferences.jsx
    */
    notificationDetails: NotificationReducer,
    /*
    src/components/MyWallet/WalletAddCreditCardSlider/WalletAddCreditCardSliderConnect.jsx
    src/components/MyWallet/WalletAddCreditCardSlider/WalletAddCreditCardSlider.jsx

    src/containers/Pages/CAMDashboard/Components/MyAddressesWrapper.jsx
    src/components/MyInfoAddresses/MyInfoAddresses.jsx
    src/components/MyInfoAddresses/MyInfoAddressList/MyInfoAddressList.jsx

    src/containers/Pages/CAMDashboard/Components/WalletWrapper.jsx
    src/components/MyWallet/MyWalletPage.jsx
    src/components/MyWallet/MyWalletPayment.jsx
    */
    paymentDetails: PaymentReducer,
    /*
    src/components/MyWallet/WalletAddCreditCardSlider/WalletAddCreditCardSliderConnect.jsx
    src/components/MyWallet/WalletAddCreditCardSlider/WalletAddCreditCardSlider.jsx
    src/components/MyWallet/WalletAddCreditCard/WalletAddCreditCard.jsx
    src/components/MyInfoAddresses/MyInfoAddressAdd/MyInfoAddressAddInputs.jsx

    src/containers/Pages/CAMDashboard/Components/MyAddressesWrapper.jsx
    src/components/MyInfoAddresses/MyInfoAddresses.jsx
    src/components/MyInfoAddresses/MyInfoAddressAdd/MyInfoAddressAdd.jsx
    src/components/MyInfoAddresses/MyInfoAddressAdd/MyInfoAddressAddInputs.jsx

    src/containers/Pages/CAMDashboard/Components/WalletWrapper.jsx
    src/components/MyWallet/MyWalletPage.jsx
    src/components/MyWallet/MyWalletPayment.jsx
    */
    addressingConstDetails: AddressingConstReducer,
    /*
    src/containers/Pages/CAMDashboard/Components/WalletWrapper.jsx
    src/components/MyWallet/MyWalletPage.jsx
    src/components/MyWallet/MyWalletCoupons.jsx
    */
    couponsDetails: CouponsReducer,
    /*
    src/components/MyInfoAddresses/MyInfoAddressAdd/MyInfoAddressAddInputs.jsx
    */
    myInfoAddressReducer: MyInfoAddressReducer,
    webvitals: WebvitalsReducer,
    syfQuickScreen: SYFQuickScreenReducer,
};

export default rootReducer;
